module.exports = __webpack_public_path__ + "assets/1ef132f1708d060daa6d6d685398716c.png";


//////////////////
// WEBPACK FOOTER
// ./app/shared/assets/logo.png
// module id = 365
// module chunks = 0